import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventIssueDeleted implements PersistenceEvent {

  public readonly type = SyncEventType.ISSUE_DELETED;
  public issueId: number;
  public isSubissue: boolean;

  constructor(issueId: number, isSubissue: boolean) {
    this.issueId = issueId;
    this.isSubissue = isSubissue;
  }

  getPayload(): object {
    const payload = {
      'issueId': this.issueId,
      'isSubissue': this.isSubissue
    };
    return payload;
  }

  static fromPayload(payload: any): EventIssueDeleted {
    return new EventIssueDeleted(
      payload['issueId'],
      payload['isSubissue']
    );
  }

}

